import ApplicationSerializer from "./application";
import { isNone } from "@ember/utils";

export default class NetworkAdapterSerializer extends ApplicationSerializer {
  usesProxy = true;

  primaryKey = "networkadapterid";

  attrs = {
    adapterType: "adaptertype",
    server: "serverid",
  };

  serialize(snapshot, options) {
    let json = super.serialize(snapshot, options);

    json.networkid = json.network ?? json.segment;

    if (isNone(json.networkid)) {
      delete json.networkid;
    }

    if (isNone(json.name)) {
      delete json.name;
    }

    if (snapshot.record.server?.isKVM) {
      delete json.adaptertype;
    }

    return json;
  }

  normalize(modelClass, resourceHash, prop) {
    let networkId = resourceHash.networkid;

    if (networkId) {
      const isVlanOrInternetNetwork = networkId.startsWith("vl") || networkId.startsWith("internet");

      if (isVlanOrInternetNetwork) {
        resourceHash.network = networkId;
        resourceHash.segment = null;
      } else {
        resourceHash.segment = networkId;
        resourceHash.network = null;
      }
    }

    return super.normalize(modelClass, resourceHash, prop);
  }
}
